import {
  SET_ASSIGNED_VEHICLES,
  SET_ASSIGNED_VEHICLES_LOADER,
  SET_ASSIGNED_VEHICLES_PAGINATION,
} from 'src/common/actions/constants';

const defaultState = {
  loader: false,
  page_data: [],
  count: {},
  pagination: {
    pageNumber: 1,
    resultPerPage: 50,
    nextOrPrev: 'first',
  },
};

export default (state = defaultState, action) => {
  const { data } = action;
  switch (action.type) {
    case SET_ASSIGNED_VEHICLES_LOADER: {
      return {
        ...state,
        loader: data,
      };
    }
    case SET_ASSIGNED_VEHICLES: {
      return {
        ...state,
        ...data,
      };
    }

    case SET_ASSIGNED_VEHICLES_PAGINATION: {
      return {
        ...state,
        pagination: data,
      };
    }
    default:
      return state;
  }
};
